import { getContext } from '@fiverr-private/fiverr_context';

export const isLoggedInUser = () => {
    const { userId } = getContext();

    return !!userId;
};
